import React from 'react';
import { X, ScrollText } from 'lucide-react';

const CHAT_RULES = [
  "Don't spam & don't use excessive capital letters when chatting.",
  "Don't harass or be offensive to other users or Gold Machine staff.",
  "Don't share any personal information (including socials) of you or other customers.",
  "Don't use alternative (alt) accounts on chat — that is strictly forbidden.",
  "No suspicious behavior that can be seen as potential scams.",
  "Don't engage in any forms of advertising, trading, selling, buying, or offering services.",
  "No discussion of streamers, Twitch, or any other similar platforms.",
  "Don't share links of any kind. Links are not permitted in chat.",
  "Don't share codes, scripts, or any other bot service.",
  "Only use English in the chat channel. Potential abuse will be sanctioned.",
  "No politics & no religion talk in chat — this one is strictly forbidden.",
];

interface ChatRulesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAccept?: () => void;
  showAccept?: boolean;
}

export const ChatRulesModal: React.FC<ChatRulesModalProps> = ({
  isOpen,
  onClose,
  onAccept,
  showAccept = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm rounded-lg">
      <div className="bg-card border border-border rounded-xl mx-3 max-w-sm w-full max-h-[80%] flex flex-col shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-border">
          <div className="flex items-center gap-2">
            <ScrollText className="h-5 w-5 text-muted-foreground" />
            <h3 className="text-foreground font-semibold text-base">Chat Rules</h3>
          </div>
          {!showAccept && (
            <button onClick={onClose} className="text-muted-foreground hover:text-foreground transition-colors">
              <X className="h-5 w-5" />
            </button>
          )}
        </div>

        {/* Rules list */}
        <div className="flex-1 overflow-y-auto px-4 py-3 space-y-2.5">
          {CHAT_RULES.map((rule, i) => (
            <div key={i} className="flex gap-2.5 text-sm">
              <span className="text-muted-foreground font-medium flex-shrink-0 w-5 text-right">{i + 1}.</span>
              <span className="text-foreground/80 leading-relaxed">{rule}</span>
            </div>
          ))}
        </div>

        {/* Accept button (shown on first open) */}
        {showAccept && (
          <div className="px-4 py-3 border-t border-border">
            <button
              onClick={() => { onAccept?.(); onClose(); }}
              className="w-full py-2.5 rounded-lg bg-primary text-primary-foreground font-semibold text-sm hover:opacity-90 transition-opacity"
            >
              I Accept
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
